import { lazy } from 'react';

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  'login-id': lazy(() => import('@page/auth/screens/login-id')),
  'login-password': lazy(() => import('@page/auth/screens/login-password')),
  'signup-id': lazy(() => import('@page/auth/screens/signup-id')),
  'signup-password': lazy(() => import('@page/auth/screens/signup-password')),
  'email-identifier-challenge': lazy(() => import('@page/auth/screens/email-identifier-challenge')),
  'reset-password-request': lazy(() => import('@page/auth/screens/reset-password-request')),
  'reset-password': lazy(() => import('@page/auth/screens/reset-password')),
  'reset-password-success': lazy(() => import('@page/auth/screens/reset-password-success')),
};

export const getScreenComponent = (screenName: string): React.ComponentType | null => {
  return SCREEN_COMPONENTS[screenName] || null;
};
